import React, { useEffect } from "react";

const TypeFormSurvey = ({ id }) => {
	const loadTypeformScript = () => {
		const script = document.createElement("script");
		script.src = "//embed.typeform.com/next/embed.js";  
		script.async = true;
		document.body.appendChild(script);
		return script;
	};

	useEffect(() => {
		const script = loadTypeformScript();
		let typeform = null;

		const observer = new MutationObserver(() => {
			typeform = document.querySelector(".tf-v1-popover");
			if (typeform) observer.disconnect(); 
		});

		observer.observe(document.body, { childList: true, subtree: true });

		return () => {
			if (script) document.body.removeChild(script);
			if (typeform) document.body.removeChild(typeform); 
			observer.disconnect();
		};
	}, []);

	return <div data-tf-live={id}></div>;
};

export default TypeFormSurvey;